import React from 'react';
import WIPMessage from '@/components/errors/WIPMessage';

const ActivitiesPanelFull = () => (
  <WIPMessage />
);

export default ActivitiesPanelFull;
